import localStorage from 'r/utils/localStorage';

export const AUTHTOKEN = 'r-auth-token-02/02/2025';
export const COOKIES_BANNER_WAS_CLOSED = 'r-cookies-banner-was-closed-01/13/2020';
export const SENTRY_LOG = 'r-sentry-log-03/23/2021';
export const CHART_SELECTED_IDX = 'r-chart-selected-idx-10-10-2022';
export const FORM_NEW_SIGNAL_DROPDOWN_STATE = 'r-form-new-signal-dropdown-state-04-25-2023';
export const UTM_TAGS = 'r-utm-tags-12-27-2022';
export const READ_MESSAGES = 'r-cache-read-messages-07-19-2023';
export const SIDEBAR_MENU_WAS_COLLAPSED = 'r-cookies-banner-was-collapsed-09/10/2025';

const RESET_STORAGE = 'r-reset-storage-10/11/2023';

if (!localStorage.getItem(RESET_STORAGE)) {
  // localStorage.clear();
  Object.keys(localStorage).forEach(key => {
    if ([AUTHTOKEN, COOKIES_BANNER_WAS_CLOSED, SENTRY_LOG, CHART_SELECTED_IDX].includes(key)) {
      return;
    }
    else {
      localStorage.removeItem(key);
    }
  });
  localStorage.setItem(RESET_STORAGE, true);
}

(() => {
  const trash = [
    'r-analysis-09/19/2024',
    'r-subscribe-banner-05/22/2022',
    'r-is-color-theme-dark-03-04-2024',
    'r-analytics-id-09/09/2020',
    'r-twitter-auth-token-01/17/2025',
    'r-auth-token-01/16/2025',
    'r-devconnect-subscribe-banner-14/11/2025',
    'r-add-to-home-screen-banner-15/11/2025',
    'r-auth-token-12/24/2024',
    'r-addresses-sent-txs-11/27/2023',
    'r-cache-trash-10-15-2022',
    'r-cache-ui-signals-table-10-21-2022',
    'r-cache-page-user-signals-10-15-2022',
    'r-cache-page-open-signal-signals-10-15-2022',
    'r-cache-page-signals-dojo-01-20-2023',
    'r-cache-page-leaders-competition-summary-10-15-2022',
    'r-cache-page-leaders-blue-10-15-2022',
    'r-cache-ui-leagues-10-22-2022',
    'r-cache-page-top-keys-table-02-07-2024',
    'r-cache-ui-participant-table-10-15-2022',
    'r-addresses-sent-txs-07/10/2023',
    'r-club-winner-modal-shown-06/17/2023',
    'r-staking-stats-10-28-2022',
    'r-reset-storage-09/09/2023',
    'r-addresses-sent-txs-02/10/2023',
    'r-addresses-sent-txs-06/07__/2023',
    'r-cache-epochs-page-data-10-15-2022',
    'r-cache-page-signals-just-10-15-2022',
    'r-free-tariff-warning-shown-01/27/2022',
    'r-addresses-sent-txs-06/07_/2023',
    'r-addresses-sent-txs-06/07/2023',
    'r-addresses-sent-txs-04/04/2023',
    'r-reset-storage-05/12/2023',
    'r-reset-storage-04/14/2023',
    'r-form-new-signal-dropdown-state-04-20-2023',
    'r-cache-page-open-signal-scroll-04-13-2023',
    'r-anonymous-news-notifications-read-04/15/2021',
    'r-anonymous-notifications-read-02/16/2021',
    'r-cache-page-open-signal-scroll-04-10-2023',
    'r-user-interview-12-27-2022',
    'r-addresses-sent-txs-10/27/2022',
    'r-cache-page-signals-dojo-10-15-2022',
    'r-reset-storage-12/24/2022',
    'r-reset-storage-12/08/2022',
    'r-reset-storage-12/23/2022',
    'r-cache-provider-competitions-10-23-2022',
    'r-reset-storage-12/06/2022',
    'r-reset-storage-12/01/2022',
    'r-reset-storage-10/28/2022',
    'r-cache-provider-competitions-10-15-2022',
    'r-cache-ui-leagues-10-15-2022',
    'r-cache-ui-signals-table-10-15-2022',
    'r-addresses-sent-txs-10/26/2022',
    'r-addresses-sent-txs-10/13/2022',
    'r-addresses-sent-txs-07/05/2022',
    'r-subscribe-banner-was-closed-08/17/2020',
    'r-subscribe-banner-was-closed-08/18/2020',
    'r-subscribe-banner-was-closed-08/19/2020',
    'auth-token',
    'r-auth-token-10/23/2020',
    'r-auth-token-08/25/2020',
    'r-auth-token-10/02/2020',
    'r-addresses-pending-txs-09/01/2020',
    'r-cookies-banner-was-closed-01/11/2020',
    'r-addresses-sent-txs-09/01/2020',
    'r-league-id-07/08/2021',
    'r-last-ethereum-chain-09/16/2020',
    'r-addresses-sent-txs-07/26/2021',
    'r-addresses-sent-txs-02/05/2022',
    'r-leagues-show-more-04/14/2022',
    'r-subscribe-banner-09/10/2020',
    'r-modal-switch-network-was-closed-06/01/2022',
    'r-addresses-sent-txs-02/07/2022',
    'r-cache-10-12-2022',
    'r-cache-09-12-2022',
    'r-leagues-show-more-04/15/2022',
    'r-cache-10-14-2022',
    'r-cache-10-15.1-2022',
    'r-cache-10-15.2-2022',
  ];
  trash.forEach(key => localStorage.removeItem(key));
})();
